import { MyCoursesSummaryInterface } from "../interfaces/my-courses-summary.interface";
import {
  RegisterCourses,
  RegisterCoursesResponse,
} from "../interfaces/register-courses.interface";
import http from "./axios";
import { handleError } from "./http-utils.service";

export const getCoursesSummaryByStudent = async (id: string) => {
  try {
    const response = await http.get<MyCoursesSummaryInterface[]>(
      `students-courses/${id}/courses-summary`,
    );
    return response.data;
  } catch (err) {
    throw handleError(err);
  }
};

export const downloadInvoiceRegistration = async (
  courseId: number,
  invoiceId: number,
) => {
  try {
    const response = await http.get<any>(
      `/students-courses/${courseId}/invoice/${invoiceId}/file`,
    );
    return response.data;
  } catch (e) {
    throw handleError(e);
  }
};

export const updateStudentCourse = async (update: RegisterCourses) => {
  try {
    const response = await http.patch<RegisterCoursesResponse>(
      `/students-courses/update-status/inprogress`,
      update,
    );
    return response.data;
  } catch (e) {
    throw handleError(e);
  }
};
